export const emailLink = {
  'Attendance confirmed!': '¡Asistencia confirmada!',
  'Cancel session': 'Cancelar sesión',
  'Changed your mind? You can still confirm your attendance.':
    '¿Cambió de opinión? Todavía puede confirmar su asistencia.',
  'Confirm attendance': 'Confirmar asistencia',
  'Confirm your attendance': 'Confirme su asistencia a la sesión',
  'Confirm your attendance at the sessions':
    'Confirme su asistencia a las sesiones',
  'Do you really want to cancel your session?':
    '¿Realmente desea cancelar su sesión?',
  'Go to the website': 'Ir al sitio',
  'Hi, {{name}}!': '¡Hola, {{name}}!',
  'Invalid link': 'Enlace inválido',
  'Remember: not attending has the same effect as a cancellation and will also be counted as a completed session.':
    'Recuerde: no asistir tiene el mismo efecto que la cancelación y también se considerará sesión realizada.',
  'Session confirmation': 'Confirmación de sesión',
  'The session time has passed and this link is no longer valid. If you need help, contact your unit.':
    'El horario de la sesión ya pasó y este enlace ya no es válido. Si necesita ayuda, comuníquese con su sucursal.',
  'There was an error loading your session. Please try again.':
    'No fue posible cargar su sesión. Inténtelo nuevamente.',
  'This link has expired': 'Este enlace expiró',
  'This session has already been cancelled.': 'Esta sesión ya fue cancelada.',
  'This session has already been completed.': 'Esta sesión ya fue finalizada.',
  'We could not find this session. Use the link from the latest confirmation email.':
    'No encontramos esta sesión. Utilice el enlace del correo de confirmación más reciente.',
  'Your attendance is already confirmed.': 'Su asistencia ya está confirmada.',
  'Your session was cancelled.': 'Su sesión fue cancelada.',
};
